import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import moment from 'moment-timezone';
import { toDisplayDateTimeString } from '../../helpers/moment-ex';
import { DataTable } from '../widgets/DataTable';
import { Icon } from '../widgets';

const QappLogsItem = (props) => {
    const { index, item } = props;

    const [show, setShow] = useState(false);
    const [showMore, setShowMore] = useState(false);

    const popover = (
        <Popover className="qapp-device-popover">
            <Popover.Content>
                <div className="close-btn" title="close">
                    <Icon className="fa fa-times" onClick={() => setShow(false)} />
                </div>
                <div className="device-content">
                    <ul>
                        <li><b>Model: </b>
                            {item.device_detail.model}
                        </li>
                        <li><b>OS Version: </b>
                            {item.device_detail.os_version}
                        </li>
                        <li><b>Software Version: </b>
                            {item.app_version}
                        </li>
                        <li><b>IMEI: </b>
                            {item.serial_number}
                        </li>
                    </ul>
                </div>
            </Popover.Content>
        </Popover>
    );

    const popoverMessage = (
        <Popover className="qapp-message-popover">
            <Popover.Content>
                <div className="close-btn" title="close">
                    <Icon className="fa fa-times" onClick={() => setShowMore(false)} />
                </div>
                <div className="message-content">
                    {item.message}
                </div>
            </Popover.Content>
        </Popover>
    );

    const copyToClipboard = (containerid) => {
        const element = document.getElementById(containerid);
        if (document.selection) {
            let range = document.body.createTextRange();
            range.moveToElementText(element);
            range.select();
            document.execCommand("Copy");
        } else if (window.getSelection) {
            let selection = window.getSelection();
            let range = document.createRange();
            range.selectNodeContents(element);
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("Copy");
        }
    }

    return <DataTable.Row className={`item ${item.is_active && "active"}`}>
        <DataTable.Cell style={{ width: "40px", textAlign: "center" }}>{index + 1}</DataTable.Cell>
        <DataTable.Cell style={{ width: "180px" }}>{item.component}</DataTable.Cell>
        <DataTable.Cell style={{}}>
            <div>
                <span className={`message-type ${item.message_type.toLowerCase()}`}>
                    {item.message_type.toLowerCase()}</span>
                <i className="fa fa-copy" onClick={() => copyToClipboard(`msg-text-${index}`)} title="Copy"></i>
            </div>
            <div className="d-flex mt-1">
                <div className="message" id={`msg-text-${index}`}>{item.message}</div>
                <OverlayTrigger
                    show={showMore}
                    onToggle={(toggle) => setShowMore(toggle)}
                    trigger="click"
                    placement="bottom-end"
                    overlay={popoverMessage}>
                    <div className="more">more
                </div>
                </OverlayTrigger>
            </div>
        </DataTable.Cell>
        <DataTable.Cell style={{ width: "180px" }}>
            <label className={`display-date-range`}>
                <span><i className="fa fa-calendar mr-1" /></span>
                {toDisplayDateTimeString(item.log_date, (moment.utc(item.log_date).year() === moment.utc().year()))}
            </label>
        </DataTable.Cell>
        <DataTable.Cell style={{ width: "50px", textAlign: "center" }}>
            <OverlayTrigger
                show={show}
                onToggle={(toggle) => setShow(toggle)}
                trigger="click"
                placement="bottom-end"
                overlay={popover}>
                <i className="fa fa-mobile mr-1" title="Device Info" />
            </OverlayTrigger>
        </DataTable.Cell>
    </DataTable.Row>
}

export default QappLogsItem;